import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { projectMembersApi } from '../api/ironworkers'
import type { Contact } from '../../ContactManagement/types'

/**
 * Fetch the Ironworkers assigned to a project (Project Members)
 */
export function useProjectMembers(projectId: string) {
  return useQuery<Contact[], Error>({
    queryKey: ['projectMembers', projectId],
    queryFn: () => projectMembersApi.list(projectId),
  })
}

/**
 * Add Ironworkers to a project (Organization only)
 */
export function useAddProjectMembers(projectId: string) {
  const queryClient = useQueryClient()
  return useMutation<{ projectId: string; contactId: string }[], Error, string[]>({
    mutationFn: (contactIds) => projectMembersApi.add(projectId, contactIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projectMembers', projectId] })
    },
  })
}

/**
 * Remove an Ironworker from a project (Organization only)
 */
export function useRemoveProjectMember(projectId: string) {
  const queryClient = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: (contactId) => projectMembersApi.remove(projectId, contactId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projectMembers', projectId] })
    },
  })
}